export class Person {
    name:string ="";
    email:string = "";
    wwid: string = "";
}